import { render, staticRenderFns } from "./OffersView3.vue?vue&type=template&id=3602c2c8&scoped=true&"
import script from "./OffersView3.vue?vue&type=script&lang=js&"
export * from "./OffersView3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3602c2c8",
  null
  
)

export default component.exports